var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center mb-5"},[_c('i',{staticClass:"far fa-meh",staticStyle:{"font-size":"54px","color":"#bdbdbd"}}),_vm._v(" "),_c('br'),_vm._v("\n  "+_vm._s(_vm.$t('reports.dontHaveData'))+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03e9befc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/empty-state/index.vue
// module id = null
// module chunks = 